import React from "react";
import { motion } from "framer-motion";
import { Download, Code, Sparkles } from "lucide-react";
import { Link } from "react-scroll";
import TypewriterEffect from "../components/TypewriterEffect";


const Home = () => {
  return (
    <section
      id="home"
      className="min-h-screen flex items-center justify-center relative pt-20 px-4 sm:px-6 lg:px-8"
    >
      <div className="max-w-6xl mx-auto w-full">
        <motion.div
          className="text-center"
          initial="hidden"
          animate="visible"
          variants={{
            hidden: {},
            visible: {
              transition: { staggerChildren: 0.4, delayChildren: 0.3 },
            },
          }}
        >
          {/* Sparkles */}
          <motion.div
            className="flex justify-center gap-2 mb-6"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            <Sparkles className="w-6 h-6 text-gray-300 animate-pulse" />
            <Sparkles className="w-6 h-6 text-gray-200 animate-pulse delay-75" />
            <Sparkles className="w-6 h-6 text-gray-400 animate-pulse delay-150" />
          </motion.div>

          {/* 👋 Hello */}
          <motion.p
            className="text-lg md:text-xl text-gray-200 mb-4 font-medium"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            👋 Hello, I'm
          </motion.p>

          {/* ✨ Name with Glow */}
          <motion.h1
            className="text-5xl md:text-7xl lg:text-8xl font-extrabold mb-6 gradient-text"
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{
              duration: 1.2,
              ease: [0.16, 1, 0.3, 1],
              delay: 0.3,
            }}
            // whileHover={{
            //   textShadow: "0px 0px 25px rgba(255,255,255,0.7)",
            //   scale: 1.05,
            //   transition: { duration: 0.3 },
            // }}
          >
            Nidhi Soni
          </motion.h1>

          {/* Role with Typewriter Effect */}
          <motion.div
            className="text-2xl md:text-4xl lg:text-5xl font-bold mb-8 leading-relaxed overflow-visible"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 1,
              ease: "easeOut",
              delay: 0.6,
            }}
          >
            <span className="text-gray-200">I'm a </span>
            <span className="inline-block align-baseline">
              <TypewriterEffect
                texts={[
                  "Full Stack Developer",
                  "Software Engineer",
                  "CSE Student",
                ]}
                speed={100}
                pause={1500}
              />
            </span>
          </motion.div>

          {/* CTA Buttons */}
          <motion.div
            className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.6, duration: 0.8 }}
          >
            <Link
              to="projects"
              smooth={true}
              duration={500}
              className="group relative px-8 py-4 bg-gray-300 rounded-full text-gray-900 font-semibold text-lg overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:bg-gray-200"
            >
              <span className="relative z-10 flex items-center gap-2">
                <Code className="w-5 h-5" />
                View My Work
              </span>
            </Link>

            <a
              href="https://drive.google.com/file/d/1EIVunfegUxkkoWH37dKJuZ0WQeOqK8zO/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="group px-8 py-4 glass rounded-full text-gray-200 font-semibold text-lg border border-gray-400 hover:border-gray-300 transition-all duration-300 hover:scale-105 flex items-center gap-2"
            >
              <Download className="w-5 h-5 group-hover:animate-bounce" />
              Download Resume
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Home;
